import React from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import ReaTag from '../components/rea-tag'
import Processo from '../components/processo'
import PerguntasFrequentes from '../components/perguntas-frequentes'
import FaleComigo from '../components/fale-comigo'
import Footer from '../components/footer'
import Whatsapp from '../components/whatsapp'
import './inicio.css'

const Inicio = (props) => {
  return (
    <main className="inicio-container1">
      <Helmet>
        <title>Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <img
        alt="Rectangle972231"
        sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
        src="/external/rectangle972231-yol9-1500h.webp"
        srcSet="/external//rectangle972231-yol9-1500h.webp 1200w, /external/rectangle972231-yol9-tablet.webp 800w, /external/rectangle972231-yol9-mobile.webp 480w"
        className="inicio-rectangle97"
      />
      <Header rootClassName="headerroot-class-name"></Header>
      <img alt="image" src="/icon.png" className="inicio-image" />
      <div className="inicio-container2">
        <div className="inicio-frame46">
          <span className="inicio-text10">Advogado</span>
          <span className="inicio-text11">
            <span>Wanderson</span>
            <br></br>
            <span>H. Cavalari</span>
          </span>
        </div>
        <section className="inicio-frame47">
          <Link to="/area/bancario">
            <ReaTag
              text="Direito Bancário"
              description="Revisão de contratos, combate a juros abusivos, renegociação de dívidas e cancelamento de negativações indevidas."
              rootClassName="rea-tagroot-class-name5"
              className="inicio-component12"
            ></ReaTag>
          </Link>
          <Link to="/area/consumidor">
            <ReaTag
              text="Direito do Consumidor"
              description="Defesa contra cobranças indevidas, propaganda enganosa e práticas abusivas de fornecedores."
              rootClassName="rea-tagroot-class-name"
              className="inicio-component13"
            ></ReaTag>
          </Link>
          <Link to="/area/familia">
            <ReaTag
              text="Direito de Família"
              description="Divórcio, guarda compartilhada, pensão alimentícia, inventário e partilha de bens."
              rootClassName="rea-tagroot-class-name4"
              className="inicio-component14"
            ></ReaTag>
          </Link>
          <Link to="/area/imobiliario">
            <ReaTag
              text="Direito Imobiliário"
              description="Contratos de compra e venda, usucapião, ações possessórias e regularização de imóveis."
              rootClassName="rea-tagroot-class-name3"
              className="inicio-component15"
            ></ReaTag>
          </Link>
          <Link to="/area/saude">
            <ReaTag
              text="Direito da Saúde"
              description="Ações contra planos de saúde, medicamentos negados e judicialização de tratamentos."
              rootClassName="rea-tagroot-class-name8"
              className="inicio-component16"
            ></ReaTag>
          </Link>
          <Link to="/area/passageiro">
            <ReaTag
              text="Direito do Passageiro"
              description="Indenizações por voo cancelado, atrasado, overbooking e bagagem extraviada."
              rootClassName="rea-tagroot-class-name7"
              className="inicio-component17"
            ></ReaTag>
          </Link>
          <Link to="/area/tributario">
            <ReaTag
              text="Direito Tributário"
              description="Revisão de débitos fiscais, recuperação de tributos pagos indevidamente e contencioso tributário."
              rootClassName="rea-tagroot-class-name2"
              className="inicio-component18"
            ></ReaTag>
          </Link>
          <Link to="/area/previdenciario">
            <ReaTag
              text="Direito Previdenciário"
              description="Aposentadoria, auxílio doença, BPC/LOAS e ações judiciais contra o INSS."
              rootClassName="rea-tagroot-class-name6"
              className="inicio-component19"
            ></ReaTag>
          </Link>
          <Link to="/area/trabalho">
            <ReaTag
              text="Direito do Trabalho"
              description="Verbas rescisórias, horas extras, assédio moral e representação em audiências trabalhistas."
              rootClassName="rea-tagroot-class-name45"
              className="inicio-component20"
            ></ReaTag>
          </Link>
        </section>
        <div id="processo" className="inicio-frame86">
          <div className="inicio-frame76">
            <div
              animation="fadeIn"
              duration="600ms"
              delay="0s"
              direction="normal"
              easing="ease"
              iteration="1"
            >
              <div
                data-thq-animate-on-reveal="true"
                className="inicio-container3"
              >
                <span className="inicio-text24">Nosso processo</span>
                <span className="inicio-text25 Content">
                  <span>
                    Explore a jornada do seu processo jurídico através da nossa
                    abordagem meticulosa e estratégica.{' '}
                  </span>
                  <br></br>
                  <span>
                    Descubra como conduzimos cada passo, dedicando atenção aos
                    detalhes para alcançar resultados sólidos.
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <br></br>
                  <span>
                    Seu caso é nossa prioridade, e nossa metodologia reflete
                    nosso compromisso inabalável com a excelência jurídica.
                  </span>
                </span>
              </div>
            </div>
          </div>
          <Processo
            text="O início de qualquer assessoria jurídica envolve o primeiro contato com o cliente. É crucial conduzir uma entrevista detalhada para entender os detalhes do caso, construindo uma relação de confiança. Perguntas claras e específicas ajudam a coletar informações relevantes, essenciais para avaliar a viabilidade do caso e definir a estratégia."
            title="Nosso Primeiro Contato"
            imageSrc="https://images.unsplash.com/photo-1598908314941-ddc4ef84509e?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDh8fG1lZXR8ZW58MHx8fHwxNzA3ODc1Nzc4fDA&amp;ixlib=rb-4.0.3&amp;h=300"
            rootClassName="processoroot-class-name"
          ></Processo>
          <Processo
            text="Com a viabilidade confirmada e a documentação em mãos, a próxima etapa é elaborar a petição inicial e criar os protocolos necessários. A redação precisa da petição, destacando argumentos jurídicos sólidos, é crucial. A atenção aos requisitos formais e procedimentais ao criar os protocolos garante a aceitação e o andamento eficiente do caso nos tribunais. Esses passos estabelecem as bases para uma representação jurídica eficaz."
            title="Criação de Petição e Protocolos"
            imageSrc="https://images.unsplash.com/photo-1534469589579-86bd01bc003a?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDZ8fG1hcmJsZSUyMGNvbHVtbnxlbnwwfHx8fDE3MDczMjMzNzB8MA&amp;ixlib=rb-4.0.3&amp;h=300"
            rootClassName="processoroot-class-name1"
          ></Processo>
        </div>
        {/* Comentário de cliente — movido para o final, no lugar das Notícias */}
        <div className="inicio-container4 inicio-comentario">
          <div className="inicio-frame72">
            <span className="inicio-text21">&ldquo;</span>
            <div className="inicio-group74">
              <img
                alt="Star102841"
                src="/external/star102841-9t9p.svg"
                className="inicio-star101"
              />
              <img
                alt="Star102841"
                src="/external/star102841-9t9p.svg"
                className="inicio-star102"
              />
              <img
                alt="Star102841"
                src="/external/star102841-9t9p.svg"
                className="inicio-star103"
              />
              <img
                alt="Star102841"
                src="/external/star102841-9t9p.svg"
                className="inicio-star104"
              />
              <img
                alt="Star102841"
                src="/external/star102841-9t9p.svg"
                className="inicio-star105"
              />
            </div>
            <span className="inicio-text22">Ana Karoline</span>
            <span className="inicio-text23 Content">
              Neste momento gostaria de agradecer por todos os serviços
              prestados pelo Dr. Wanderson Cavalari durante o curso do processo,
              sempre muito solicito e com atendimento muito acolhedor.
              Manteve-me ciente de todas as etapas e procedimentos do litígio,
              com orientações assertivas. Estou satisfeita até aqui e recomendo
              seus serviços. Dr. muito obrigada!
            </span>
          </div>
        </div>
        <div id="faq" className="inicio-container5">
          <PerguntasFrequentes rootClassName="perguntas-frequentesroot-class-name"></PerguntasFrequentes>
        </div>
        <div id="falecomigo" className="inicio-container6">
          <FaleComigo></FaleComigo>
        </div>
      </div>
      <Footer rootClassName="footerroot-class-name1"></Footer>
      <Whatsapp></Whatsapp>
    </main>
  )
}

export default Inicio
